import styled from "styled-components";


export const ItemsContainer = styled.div`
  display:inline-block;    
  margin-right: 30px;
`;

export const PageContainer = styled.div`
  display:inline-block;
`;

export const SelectContainer = styled.div`
  display:inline-block;
  width : 150px;
  .page-size-selector{
    width:50px;
    display:inline-block;
    margin-right: 10px;
  }
`;

export const PaginatorContainer = styled.div`
  font-family: arial;
  color: #a8a6a6;
  font-size: 12px;

  .seperator{
    font-style: normal;
    display:inline-block;
    margin: 10px;
  }
  .left-pagination,.right-pagination{
    cursor: pointer;
    height: 10px;
    width: 10px;
    padding: 10px 10px 0px 10px;
    font-size: 18px;
    font-weight: bold;
    position: relative;
    top: 2px;
    left: 5px;
  }

`;

